var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.tcpaHistory.length > 0
        ? _c("HighChartsTcpaHistory", {
            attrs: {
              data: _vm.tcpaHistory,
              "moment-timezone-id": _vm.accountTranslatedTimeZoneId
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("TcpaHistoryTable", {
        attrs: {
          "tcpa-history-data": _vm.tcpaHistory,
          "loading-status": _vm.actionStatus.status,
          "moment-timezone-id": _vm.accountTranslatedTimeZoneId
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }